import { render, staticRenderFns } from "./Technicians.vue?vue&type=template&id=981b3f62"
import script from "./Technicians.vue?vue&type=script&lang=js"
export * from "./Technicians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports